import styled from '@emotion/styled';

export const MemberListFooter = styled('div')(({ theme }) => ({
  display: 'flex',
  paddingTop: theme.spacing[8],
}));
